export default __webpack_public_path__ + "static/media/NotFound.0733371f.jpg";